import { render, staticRenderFns } from "./serveyRecord.vue?vue&type=template&id=a90a69d0&"
import script from "./serveyRecord.vue?vue&type=script&lang=js&"
export * from "./serveyRecord.vue?vue&type=script&lang=js&"
import style0 from "./serveyRecord.vue?vue&type=style&index=0&id=a90a69d0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports